import { render, staticRenderFns } from "./Manu.vue?vue&type=template&id=1e974166&"
import script from "./Manu.vue?vue&type=script&lang=js&"
export * from "./Manu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports